import React from 'react';

import styled from '@emotion/styled';

// import CollapseableSegment from '../../components/CollapseableSegment/CollapseableSegment';

interface IpackageStatus {
  [props: string]: { num: number };
}

interface IPackageStatusGraph {
  status?: string;
}

const packageStatus: IpackageStatus = {
  'At Origin': { num: 0 },
  'Processing Clearance': { num: 1 },
  Cleared: { num: 2 },
  'At Warehouse': { num: 3 },
  'Out For Delivery': { num: 4 },
  Delivered: { num: 5 },
};

const statusList = [
  'At Origin',
  'Processing Clearance',
  'Cleared',
  'At Warehouse',
  'Out For Delivery',
  'Delivered',
];

const PackageStatusGraph: React.FC<IPackageStatusGraph> = ({
  status = 'Cleared',
}) => {
  let statusPin = packageStatus[status]?.num || 0;

  const Tracker = () => (
    <Ul>
      {statusList.map((status, index) => {
        if (index <= statusPin) {
          return (
            <li key={index} className="status">
              {status}
            </li>
          );
        } else if (index === statusPin + 1) {
          return (
            <li key={index} className="future">
              {status}
            </li>
          );
        }
        return <li key={index}>{status}</li>;
      })}
    </Ul>
  );

  return (
    <>
      <Container className="desktop">
        <Header>Package Status</Header>
        <Tracker />
      </Container>

      {/* <Container className="mobile">
        <CollapseableSegment title="Package Status">
          <Tracker />
        </CollapseableSegment>
      </Container> */}
    </>
  );
};

export default PackageStatusGraph;

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.foundationBlackB10};
  padding: 1.75rem 1.44rem;
  display: flex;
  flex-direction: column;
  gap: 1.63rem;

  &.mobile {
    display: none;
  }

  @media (max-width: 480px) {
    font-size: 1rem;

    /* &.desktop {
      display: none;
    }

    &.mobile {
      display: flex;
    } */
  }
`;

const Header = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: black;
`;

const Ul = styled.ul`
  list-style: none;
  padding: 0px;
  margin-left: -1rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-transform: capitalize;

  & li:first-of-type {
    margin-bottom: 1rem;
  }

  & li {
    position: relative;
    margin-left: 20px;
    padding-left: 30px;
  }

  & li::before {
    content: url('/static/svg/tick-full-circle.svg');
    position: absolute;
    left: 0;
    top: calc(0% + 0px);
    z-index: 1;
  }

  & li.future::before {
    content: url('/static/svg/tick-circle.svg');
    position: absolute;
    left: 0;
    top: calc(0% + 0px);
    z-index: 1;
  }

  & li.status::before {
    content: url('/static/svg/tick-checked-circle.svg');
    position: absolute;
    left: 0;
    top: calc(0% + 0px);
    z-index: 1;
  }

  & > :not(:first-of-type)::after {
    content: '';
    position: absolute;
    top: -66px;
    left: 11px;
    width: 1px;
    height: 300%;
    border-left: 0.125rem solid ${({ theme }) => theme.palette.borderColor3};
  }
  & > .status:not(:first-of-type)::after {
    border-left: 0.125rem solid #22b231;
  }

  & > .future:not(:first-of-type)::after {
    border-left: 0.125rem solid #f46f3b;
  }
`;
